export function sizeCalc(long) {
    if (long < 3) {
        return "--xl";
    } else if (long < 25) {
        return "--l";
    } else if (long < 51) {
        return "--m";
    } else if (long < 125) {
        return "--s";
    } else {
        return "--xs";
    }
}